var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_6149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3237 8.66081C13.3237 11.9919 10.9919 13.6575 8.22038 14.6235C8.07525 14.6727 7.9176 14.6703 7.77401 14.6169C4.99585 13.6575 2.66406 11.9919 2.66406 8.66081V3.99723C2.66406 3.82054 2.73425 3.65108 2.8592 3.52614C2.98414 3.4012 3.15359 3.33101 3.33029 3.33101C4.66274 3.33101 6.3283 2.53154 7.48753 1.51887C7.62867 1.39829 7.80822 1.33203 7.99386 1.33203C8.1795 1.33203 8.35905 1.39829 8.50019 1.51887C9.66609 2.5382 11.325 3.33101 12.6574 3.33101C12.8341 3.33101 13.0036 3.4012 13.1285 3.52614C13.2535 3.65108 13.3237 3.82054 13.3237 3.99723V8.66081Z",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 7.99456L7.32854 9.32701L9.99344 6.66211",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_6149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldGray);
export default __webpack_public_path__ + "static/media/shield_gray.1f89d3a0a9de864766486427f549650e.svg";
export { ForwardRef as ReactComponent };